module.exports = __webpack_public_path__ + "img/17-image-1@2x.62c3d16e.png";